
import Vue from "vue";

export default Vue.extend({
	data() {
		return {
			transition: "",
			isSwiping: false,
			startX: 0
		};
	},
	props: {
		value: [Boolean, Number],
		hover: Boolean,
		maxWidth: {
			type: Number,
			default: 250
		},
		swipeOpen: Boolean
	},
	computed: {
		computedValue():string | undefined {
			if (this.value === true) {
				return undefined;
			}
			if (this.value === false) {
				return "0";
			}
			return `${this.value}px`;
		},
		isClosed():boolean {
			return this.value == 0;
		},
		isOpened():boolean {
			return this.value === true || this.value == this.maxWidth;
		}
	},
	watch: {
		swipeOpen(currentValue:boolean, oldValue:boolean) {
			if (oldValue) {
				/*document.removeEventListener("touchstart", this.swipeTouchStart);
				document.removeEventListener("touchmove", this.swipeTouchMove);
				document.removeEventListener("touchend", this.swipeEnd);*/
			}
			if (currentValue) {
				/*document.addEventListener("touchstart", this.swipeTouchStart);
				document.addEventListener("touchmove", this.swipeTouchMove);
				document.addEventListener("touchend", this.swipeEnd);*/
			}
		},
	},
	methods: {
		swipeTouchStart(e:TouchEvent) {
			if (e.touches.length != 1) return;
			let rect = this.$el.getBoundingClientRect();
			let touch = e.touches.item(0) as Touch;
			if (this.isClosed) {
				if (touch.pageX < 50 && touch.pageY > rect.top) {
					this.isSwiping = true;
					this.startX = touch.pageX;
				}
			}
			if (this.isOpened) {
				if (touch.pageX < this.maxWidth && touch.pageY > rect.top) {
					this.isSwiping = true;
					this.startX = touch.pageX - this.maxWidth;
				}
			}
		},
		swipeTouchMove(e:TouchEvent) {
			if (!this.isSwiping) return;
			let touch = e.touches.item(0) as Touch;
			let val = touch.pageX - this.startX;
			if (val < 0) {
				val = 0;
			}
			if (val > this.maxWidth) {
				val = this.maxWidth;
			}
			this.$emit("input", val);
		},
		swipeEnd(e:TouchEvent) {
			if (!this.isSwiping) return;
			if (e.target) {
				let target = e.target as HTMLElement;
				if (target.className.indexOf("w-drawer-item-group-title") != -1) {
					return;
				}
			}
			this.isSwiping = false;
			let half = this.maxWidth / 2;
			if (this.value > half) {
				this.$emit("input", this.maxWidth);
			} else {
				this.$emit("input", 0);
			}
		}
	},
	created() {
		if(this.swipeOpen) {
			/*document.addEventListener("touchstart", this.swipeTouchStart);
			document.addEventListener("touchmove", this.swipeTouchMove);
			document.addEventListener("touchend", this.swipeEnd);*/
		}
	},
	destroyed() {
		if(this.swipeOpen) {
			/*document.removeEventListener("touchstart", this.swipeTouchStart);
			document.removeEventListener("touchmove", this.swipeTouchMove);
			document.removeEventListener("touchend", this.swipeEnd);*/
		}
	}
});
